"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterModesToDriveConditionsOnly = filterModesToDriveConditionsOnly;
exports.filterModesToReferencedOnly = filterModesToReferencedOnly;
const ModeReferenceCondition_1 = require("../ModeReferenceCondition");
function filterModesToDriveConditionsOnly(modes, signals) {
    const referencedModeIds = new Set();
    for (const signal of signals) {
        if (!signal.supportedDriveModes || signal.supportedDriveModes.length === 0) {
            continue;
        }
        for (const driveMode of signal.supportedDriveModes) {
            if (!driveMode.conditions || driveMode.conditions.length === 0) {
                continue;
            }
            for (const condition of driveMode.conditions) {
                if ('condition' in condition && 'mode' in condition.condition) {
                    referencedModeIds.add(condition.condition.mode);
                }
            }
        }
    }
    return modes.filter((mode) => referencedModeIds.has(mode.id));
}
function collectDirectModeReferences(signals, boundaries) {
    const referenced = new Set();
    for (const signal of signals) {
        for (const driveMode of signal.supportedDriveModes ?? []) {
            for (const condition of driveMode.conditions ?? []) {
                if ('condition' in condition && 'mode' in condition.condition) {
                    referenced.add(condition.condition.mode);
                }
            }
        }
    }
    for (const boundary of boundaries) {
        for (const condition of boundary.conditions ?? []) {
            if ((0, ModeReferenceCondition_1.isModeReferenceCondition)(condition)) {
                referenced.add(condition.mode);
            }
        }
    }
    return referenced;
}
function filterModesToReferencedOnly(modes, signals, boundaries) {
    if (modes.length === 0) {
        return [];
    }
    const referencedModeIds = collectDirectModeReferences(signals, boundaries);
    const modesById = new Map(modes.map((mode) => [mode.id, mode]));
    const queue = [...referencedModeIds];
    while (queue.length > 0) {
        const id = queue.pop();
        if (id === undefined) {
            continue;
        }
        const mode = modesById.get(id);
        if (mode === undefined) {
            continue;
        }
        for (const precondition of mode.preconditions ?? []) {
            if ((0, ModeReferenceCondition_1.isModeReferenceCondition)(precondition.condition) && !referencedModeIds.has(precondition.condition.mode)) {
                referencedModeIds.add(precondition.condition.mode);
                queue.push(precondition.condition.mode);
            }
        }
    }
    return modes.filter((mode) => referencedModeIds.has(mode.id));
}
//# sourceMappingURL=ModeFiltering.js.map